import request from "utils/request";

export async function getWizards() {
	return request("/rest/xwizards");
}

export async function deleteWizards(ids) {	
	return request("/rest/xwizards", {
		method: "DELETE",
		body: ids
	});
}

export async function addWizard(payload) {
	return request("/rest/xwizards", {
		method: "PUT",
		body: payload
	});
}

export async function renameWizard(payload) {
	return request("/rest/xwizard/rename", {
		method: "POST",
		body: payload	
	});
}

export async function duplicateWizard(payload) {
	return request("/action/duplicate/xwizard/" + payload.id, {
		method: "POST",
		body: payload	
	});
}
